import { render } from "./FiltersDataTableComponent.vue?vue&type=template&id=15a5ce31&scoped=true"
import script from "./FiltersDataTableComponent.vue?vue&type=script&lang=js"
export * from "./FiltersDataTableComponent.vue?vue&type=script&lang=js"

import "./FiltersDataTableComponent.vue?vue&type=style&index=0&id=15a5ce31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a5ce31"]])

export default __exports__